import styled from "styled-components";

const CardImage = styled.img`
  background: ${({ backgroundColor }) => backgroundColor};
  object-fit: ${({ objectFit }) => objectFit};
  height: ${({ height }) => height};
`;

export default CardImage;
